import { ApiHandler } from '../api-handler';
import { ApiEndpoints, HttpMethod } from '../constants';
import type { DoctorOnboardingApiResponse, OnboardingUpdate } from './types';

export const OnboardingApiService = {
  get: () =>
    ApiHandler.makeApiRequest<DoctorOnboardingApiResponse>({
      endpoint: ApiEndpoints.Users.Onboarding,
      method: HttpMethod.Get,
      rejectOnError: true,
    }),
  update: (data: OnboardingUpdate) =>
    ApiHandler.makeApiRequest<DoctorOnboardingApiResponse, OnboardingUpdate>({
      endpoint: ApiEndpoints.Users.Onboarding,
      method: HttpMethod.Patch,
      data,
      rejectOnError: true,
    }),
} as const;
